import { gap } from "components/styles/constants.styles";
import styled from "styled-components";

const RewardDetailsItem = styled.div`
    margin-left: 34px;
    margin-top: ${gap}
`;

export default RewardDetailsItem;